export const openAIAdvancedConfigData = [
  {
    name: "openAiTemperature",
    label: "Temperature (between 0 and 2)",
    subtitle: "Higher numbers like 0.9 make the output more random and creative. Lower numbers like 0.2 make it more focused and predictable in response generation.",
    rules: [
      {
        type: "number",
        min: 0.0,
        max: 2.0,
        message: "Temperature must be between 0 and 2",
        step: 0.1
      },
    ],
  },
  {
    name: "openAiPresence_penalty",
    label: "Presence Penalty (between 0 and 2)",
    subtitle: "Reduces repeated words to keep the conversation fresh. If the AI says, 'The cat is cute', the presence penalty will make it less likely to say 'The cat is cute' again soon. Instead, it might say, 'The feline is adorable'. ",
    rules: [
      {
        type: "number",
        min: 0.0,
        max: 2.0,
        message: "Presence Penalty must be between 0 and 2",
        step: 0.1
      },
    ],
  },
  {
    name: "openAiFrequency_penalty",
    label: "Frequency Penalty (between 0 and 2)",
    subtitle: "Reduces repeated words to promote a diverse vocabulary. If the AI keeps saying, 'The car is fast', the frequency penalty will make it less likely to say 'fast' again soon. Instead, it might say, 'The car is speedy' or 'The vehicle zooms by'.",
    rules: [
      {
        type: "number",
        min: 0.0,
        max: 2.0,
        message: "Frequency Penalty must be between 0 and 2",
        step: 0.1
      },
    ],
  },
  {
    name: "openAiMax_tokens",
    label: "Max Token (up to 4096 tokens)",
    subtitle: "Limits the combined number of tokens for input and output",
    rules: [
      {
        type: "number",
        min: 0,
        max: 4096,
        message: "Max Token must be up to 4096 tokens",
        step: 1
      },
    ],
  },
  {
    name: "openAiTopP",
    label: "Top P (between 0 and 1)",
    subtitle: "Nucleus sampling is another way to choose words. Instead of using temperature, it looks at the top choices",
    rules: [
      {
        type: "number",
        min: 0.0,
        max: 1.0,
        message: "Top P must be between 0 and 1",
        step: 0.1
      },
    ],
  },
];

export const geminiAdvancedConfigData = [
  {
    name: "geminiTemperature",
    label: "Temperature (between 0 and 2)",
    subtitle: "Higher numbers like 0.9 make the output more random and creative. Lower numbers like 0.2 make it more focused and predictable in response generation.",
    rules: [
      {
        type: "number",
        min: 0,
        max: 2,
        message: "Temperature must be between 0 and 2",
        step: 0.1
      },
    ],
  },
  {
    name: "geminiTopK",
    label: "Top K (between 1 and 40)",
    subtitle: "By setting Top K, you can control how many word options the AI considers, helping balance between creativity and coherence.",
    rules: [
      {
        type: "number",
        min: 0,
        max: 40,
        message: "Top K must be between 1 and 40",
        step: 1
      },
    ],
  },
  {
    name: "geminiTopP",
    label: "Top P (between 0 and 1)",
    subtitle: "Nucleus sampling is another way to choose words. Instead of using temperature, it looks at the top choices",
    rules: [
      {
        type: "number",
        min: 0,
        max: 1,
        message: "Top P must be between 0 and 1",
        step: 0.1
      },
    ],
  },
  {
    name: "geminiMaxOutputTokens",
    label: "Max Token (up to 2048 tokens)",
    subtitle: "Limits the combined number of tokens for input and output",
    rules: [
      {
        type: "number",
        min: 0,
        max: 2048,
        message: "Max Token must be up to 2048 tokens",
        step: 1
      },
    ],
  },
];

export const claudeAdvancedConfigData = [
  {
    name: "claudeAiTemperature",
    label: "Temperature (between 0 and 2)",
    subtitle: "Higher numbers like 0.9 make the output more random and creative. Lower numbers like 0.2 make it more focused and predictable in response generation.",
    rules: [
      {
        type: "number",
        min: 0,
        max: 2,
        message: "Temperature must be between 0 and 2",
        step: 0.1
      },
    ],
  },
  {
    name: "ClaudeAIMaxToken",
    label: "Max Token (up to 4096 tokens)",
    subtitle: "Limits the combined number of tokens for input and output",
    rules: [
      {
        type: "number",
        min: 0,
        max: 4096,
        message: "Max Token must be up to 4096 tokens",
        step: 1
      },
    ],
  },
];

export const deepseekAdvancedConfigData = [
  {
    name: "deepseekTemperature",
    label: "Temperature (between 0 and 2)",
    subtitle:
      "Higher numbers like 0.9 make the output more random and creative. Lower numbers like 0.2 make it more focused and predictable in response generation.",
    rules: [
      {
        required: false,
        type: "number",
        min: 0,
        max: 2,
        step: 0.1,
      },
    ],
  },
  {
    name: "deepseekMaxTokens",
    label: "Max Token (up to 16384 tokens)",
    subtitle: "Limits the combined number of tokens for input and output",
    rules: [
      {
        required: false,
        type: "number",
        min: 0,
        max: 16384,
        step: 10,
      },
    ],
  },
  {
    name: "deepseekTopP",
    label: "Top P (between 0 and 1)",
    subtitle:
      "Nucleus sampling is another way to choose words. Instead of using temperature, it looks at the top choices",
    rules: [
      {
        required: false,
        type: "number",
        min: 0,
        max: 1,
        step: 0.1,
      },
    ],
  },
  {
    name: "deepseekTopK",
    label: "Top K (between 1 and 100)",
    subtitle:
      "By setting Top K, you can control how many word options the AI considers, helping balance between creativity and coherence.",
    rules: [
      {
        required: false,
        type: "number",
        min: 0,
        max: 100,
        step: 1,
      },
    ],
  },
  {
    name: "deepseekRepetitionPenalty",
    label: "Frequency Penalty (between 1 and 2)",
    subtitle:
      "Reduces repeated words to promote a diverse vocabulary. If the AI keeps saying, 'The car is fast', the frequency penalty will make it less likely to say 'fast' again soon. Instead, it might say, 'The car is speedy' or 'The vehicle zooms by'.",
    rules: [
      {
        required: false,
        type: "number",
        min: 1,
        max: 2,
        step: 0.01,
      },
    ],
  },
];
